module.exports = __webpack_public_path__ + "static/media/bronze.0362132a.png";